<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('zhuima.taskConfig.facebookNum')" prop="facebookNum" >
        <a-input-number :min="0" style="width: 100%" :precision="0"  v-model="form.facebookNum" :placeholder="$t('zhuima.taskConfig.inputFacebookNum')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskConfig.youtubeNum')" prop="youtubeNum" >
        <a-input-number :min="0" style="width: 100%" :precision="0"   v-model="form.youtubeNum" :placeholder="$t('zhuima.taskConfig.inputYoutubeNum')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskConfig.tiktok')" prop="tiktok" >
        <a-input-number :min="0" style="width: 100%" :precision="0"   v-model="form.tiktok" :placeholder="$t('zhuima.taskConfig.inputTiktok')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskConfig.openMessage')" prop="openMessage" >
        <a-input-number :min="0" style="width: 100%" :precision="0"   v-model="form.openMessage" :placeholder="$t('zhuima.taskConfig.inputOpenMessage')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskConfig.likeNum')" prop="likeNum" >
        <a-input-number :min="0" style="width: 100%" :precision="0"   v-model="form.likeNum" :placeholder="$t('zhuima.taskConfig.inputLikeNum')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskConfig.lookVideoOne')" prop="lookVideoOne" >
        <a-input-number :min="0" style="width: 100%" :precision="0"   v-model="form.lookVideoOne" :placeholder="$t('zhuima.taskConfig.inputLookVideoOne')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskConfig.lookVideoTwo')" prop="lookVideoTwo" >
        <a-input-number :min="0" style="width: 100%" :precision="0"   v-model="form.lookVideoTwo" :placeholder="$t('zhuima.taskConfig.inputLookVideoTwo')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskConfig.advertisementNum')" prop="advertisementNum" >
        <a-input-number :min="0" style="width: 100%" :precision="0"   v-model="form.advertisementNum" :placeholder="$t('zhuima.taskConfig.inputAdvertisementNum')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('zhuima.taskConfig.maxAdvertisementNum')" prop="maxAdvertisementNum" >
        <a-input-number :min="0" style="width: 100%" :precision="0"   v-model="form.maxAdvertisementNum" :placeholder="$t('zhuima.taskConfig.inputMaxAdvertisementNum')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTaskConfig, addTaskConfig, updateTaskConfig } from '@/api/taskConfig/taskConfig'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        facebookNum: null,

        youtubeNum: null,

        tiktok: null,

        openMessage: null,

        likeNum: null,

        advertisementNum: null,

        maxAdvertisementNum: null,

        lookVideoOne: null,

        lookVideoTwo: null,

        lookVideoThree: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        facebookNum: null,
        youtubeNum: null,
        tiktok: null,
        openMessage: null,
        likeNum: null,
        advertisementNum: null,
        maxAdvertisementNum: null,
        lookVideoOne: null,
        lookVideoTwo: null,
        lookVideoThree: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTaskConfig({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateTaskConfig(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addTaskConfig(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
